import { Box, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import { JobStatsPoint } from '../../../../types/dashboard';
import GenericTable from '../../../../shared/GenericTable';
import { dashboardSummaryTableDefaults } from '../../dashboardReportTableConfig';

type JobsCreatedReportListProps = {
    points: JobStatsPoint[];
};

type SummaryRow = JobStatsPoint & { id: number };

export default function JobsCreatedReportList({
    points,
}: JobsCreatedReportListProps) {
    const columns: MRT_ColumnDef<SummaryRow>[] = useMemo(
        () => [
            {
                accessorKey: 'label',
                header: 'Period',
                size: 180,
            },
            {
                accessorKey: 'jobCount',
                header: 'Jobs Created',
                size: 180,
            },
        ],
        [],
    );

    const rows = useMemo(
        () =>
            (points ?? []).map((point, index) => ({
                id: index + 1,
                ...point,
            })),
        [points],
    );

    if (!rows.length) {
        return (
            <Typography sx={{ mt: 4 }} variant='body2'>
                No jobs created found for this selection.
            </Typography>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            <GenericTable
                {...dashboardSummaryTableDefaults}
                columns={columns}
                data={rows}
                tableName='Jobs Created Summary'
            />
        </Box>
    );
}
